import { createContext } from "react";
export const MainStore = createContext();
